import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ShareComponent } from './share.component';
import { ShareSmartComponent } from './share-smart.component';
import { AttachmentComponent } from './attachment.component';
import { ReloadComponent } from './reload.component';
import { BrandingResolverService } from '../branding/branding-resolver.service';
import { EmbedResolverService } from '../embed/embed-resolver.service';
import { ErrorResolverService } from '../errors/error-resolver.service';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'share/:shareId/:securityKey',
        component: ShareComponent,
        resolve: [
          BrandingResolverService,
          EmbedResolverService,
          ErrorResolverService,
        ],
        children: [
          {
            path: ':nodeId',
            component: ShareSmartComponent
          },
          {
            path: '',
            component: ShareSmartComponent
          }
        ]
      },
      {
        path: 'video/:shareId/:securityKey/:nodeId/:attachmentId/:displayName',
        component: AttachmentComponent
      },
      {
        path: 'audio/:shareId/:securityKey/:nodeId/:attachmentId/:displayName',
        component: AttachmentComponent
      },
      {
        path: 'image/:shareId/:securityKey/:nodeId/:attachmentId/:displayName',
        component: AttachmentComponent
      },
      {
        path: 'attachment/:shareId/:securityKey/:attachmentId/:displayName',
        component: ReloadComponent
      },
      {
        path: 'attachment/:shareId/:securityKey/:nodeId/:attachmentId/:displayName',
        component: ReloadComponent
      }
    ])
  ]
})
export class ShareRoutingModule { }
